import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import qs from 'qs';

async function fetchCurrentValueAumByDate({ queryKey }) {
  const [, firmId, dateRangeKey, fundTagIds] = queryKey;
  const queryParams = qs.stringify({ firmId, fundTagIds });

  const url = `dashboard/current-value-aum-by-date/${dateRangeKey}?${queryParams}`;

  const { data } = await api.get(url);

  return data.data;
}

function useCurrentValueAumByDate({
  firmId,
  dateRangeKey,
  enabled,
  fundTagIds,
}) {
  return useQuery({
    queryKey: [
      'dashboard-current-value-aum-by-date',
      firmId,
      dateRangeKey,
      fundTagIds,
    ],
    queryFn: fetchCurrentValueAumByDate,
    placeholderData: keepPreviousData,
    staleTime: 4 * 60 * 60 * 1000,
    enabled,
  });
}

export default useCurrentValueAumByDate;
